import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import * as intakeFormsActions from '../intake-forms.actions';
import * as modifyIntakeActions from '../modify-intake-form/modify-intake-form.actions';
import * as intakeFormConstants from '../modify-intake-form/intake-form-constants';
import { ssgFormsAdapters } from '../../common';
import { Title } from '../../layout';
import { validateIntakeFormActions, IntakeFormValidation } from '../validate-intake-form';
import { SsgFormComponent, LoadingPane } from '@social-solutions/ssg-forms';

const validationMessage = "Settings may have changed in ETO since this intake form was created." +
   " The following issues will prevent applicants from completing this intake form:";

export class PreviewIntakeFormComponent extends Component {

  componentDidMount() {
    const { intakeFormsActions, modifyIntakeActions, match, modifyIntake, validateIntakeFormActions } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { getFormPreview } = intakeFormsActions;
    const { fetchCurrentFormPreview, preserveEdits } = modifyIntakeActions;
    const { previewModifiedFormState } = modifyIntake || {};
    const { siteId, programId, inProgress, formValue } = previewModifiedFormState || {};
    const { validateNewIntakeForm, validateEditedIntakeForm, validateExistingIntakeForm } = validateIntakeFormActions;

    if(!!id && id === intakeFormConstants.createNewIntakeId) {
      fetchCurrentFormPreview(null, siteId, programId, formValue);
      validateNewIntakeForm(siteId, programId, formValue);
    }
    else  {
      if(inProgress) {
        fetchCurrentFormPreview(id, siteId, programId, formValue);
      } else {
        getFormPreview(id);
      }
      if(formValue) {
        validateEditedIntakeForm(id, siteId, programId, formValue);
      }
      else {
        validateExistingIntakeForm(id);
      }
    }
    preserveEdits(true);
  }

  componentDidUpdate(prevProps) {
    const { match : oldMatch } = prevProps;
    const { params : oldParams } = oldMatch;
    const { id : oldId } = oldParams;
    const { intakeFormsActions, modifyIntakeActions, match, modifyIntake, intake } = this.props;
    const { params } = match || {};
    const { id } = params || {};

    if(oldId !== id){
      const { previewModifiedFormState } = modifyIntake || {};
      const { formPreviews } = intake || {};
      const { siteId, programId, inProgress, formValue, currentEditPreview } = previewModifiedFormState || {};
      const { isFetching : inProgressIsFetching } = currentEditPreview;

      if(!!inProgress) {
        if(!inProgressIsFetching){
          modifyIntakeActions.fetchCurrentFormPreview(id, siteId, programId, formValue);
        }
      } else {
        const form = formPreviews.get(id);
        const { isFetching : savedFormIsFetching } = form || { isFetching : false }
        if(!savedFormIsFetching) {
          intakeFormsActions.getFormPreview(id);
        }
      }
    }

    modifyIntakeActions.preserveEdits(true);
  }

  render() {
    const { intake, modifyIntake, match, redirectTo, validateIntake } = this.props;
    const { params } = match || {};
    const { id } = params || {};
    const { previewModifiedFormState, intakePreviewRedirect } = modifyIntake || {};
    const { inProgress, currentEditPreview, formValue } = previewModifiedFormState || {};
    const { formPreviews, intakeForms } = intake || {};
    const formPreviewState = formPreviews && formPreviews.get(id);
    const { data : savedForm } = formPreviewState || {};
    const { data : editedForm } = currentEditPreview || {};
    const { data : intakeFormData } = intakeForms || {};
    const { results : intakeFormResults } = intakeFormData || {};
    var { siteId, programId } = previewModifiedFormState || {};
    if (!siteId || !programId) {
      siteId = intakeFormResults && intakeFormResults.find( el => el.id === id) && intakeFormResults.find( el => el.id === id).siteId;
      programId = intakeFormResults && intakeFormResults.find( el => el.id === id) && intakeFormResults.find( el => el.id === id).programId;
    }
    // use saved form if no edits in flight, else need dynamically constructed intake form
    const form = !!inProgress ? editedForm : savedForm;
    const backUrl = !!inProgress ? (!!id && id !== intakeFormConstants.createNewIntakeId) ? `/intake-forms/edit/${id}${intakePreviewRedirect}`
      : `/intake-forms/create/${siteId}/${programId}${intakePreviewRedirect}` : `/intake-forms`;

    var resetFormButton = {
      id: "reset-form-btn",
      type: "button",
      display: "Reset Form",
      ariaLabel: "Reset Form",
      buttonType: "secondary",
      functionType: "reset",
    };

    var redirectButton = {
      id: "redirect-btn",
      type: "submit",
      display: "Back",
      ariaLabel: "Go Back",
      buttonType: "primary",
      functionType: "none",
      onClick: (state) => redirectTo(backUrl),
    };

    const ssgFormProps = {
      id: !!id ? id : "intake-preview-id",
      form,
      disableValidationResultList: true,
      buttonLayout: [ resetFormButton, redirectButton ],
      recaptchaKey: process.env.RECAPTCHA_PUBLIC_KEY
    };

    var validationState;
    if(!!id && id === intakeFormConstants.createNewIntakeId) {
      validationState = validateIntake.get('newFormValidation');
    }
    else  {
      if(formValue) {
        validationState = validateIntake.getIn(['editFormValidation', id]);
      }
      else {
        validationState = validateIntake.getIn(['formValidation', id]);
      }
    }
    const { data: intakeValidationResult } = validationState || {};
    const loadingState = ssgFormsAdapters.convertLoadingState(inProgress ? currentEditPreview : formPreviewState);

    return (
      <LoadingPane
        loadingState={loadingState}
        loadingMessage={'Loading intake form...'}>
        <Title title="Preview Intake Form"/>
        <IntakeFormValidation
          validationResult={intakeValidationResult}
          titleMessage={validationMessage}
          loadingErrorCondition={"Cannot preview form."}
          loadingErrorInstructions={"Try previewing the form again. If the issue persists, contact technical support."}/>
        <div  className="intake-form">
          <SsgFormComponent {...ssgFormProps}/>
        </div>
      </LoadingPane>
    );
  }
}

PreviewIntakeFormComponent.propTypes = {
  intake : PropTypes.any,
  intakeFormsActions : PropTypes.any,
  modifyIntake : PropTypes.any,
  modifyIntakeActions : PropTypes.any,
  redirectTo : PropTypes.func,
};

const mapStateToProps = ({ intake, modifyIntake, validateIntake }) => {
  return {
    intake,
    modifyIntake,
    validateIntake
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    intakeFormsActions: bindActionCreators(intakeFormsActions, dispatch),
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
    validateIntakeFormActions: bindActionCreators(validateIntakeFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewIntakeFormComponent);
